/**
 * Superadmin Page
 *
 * Superadmin interface with tabs for:
 * - Admin users management (role assignments)
 * - Organizations management (create, activate, deactivate)
 * - Endpoint groups access per organization
 * - Page access per organization
 */

import type { TabItem } from "@/components/ui/navigation/Tabs";
import { Tabs } from "@/components/ui/navigation/Tabs";
import { SectionHeader } from "@/components/ui/navigation/SectionHeader";
import { AdminsSection } from "@/components/superadmin/AdminsSection";
import { OrganizationsSection } from "@/components/superadmin/OrganizationsSection";
import { EndpointGroupsSection } from "@/components/superadmin/EndpointGroupsSection";
import { PagesSection } from "@/components/superadmin/PagesSection";
import React, { useMemo } from "react";
import styles from "./SuperadminPage.module.css";

export const SuperadminPage: React.FC = () => {
  // Define tabs
  const tabs: TabItem[] = useMemo(
    () => [
      {
        id: "admins",
        label: "Adminbrukere",
        content: <AdminsSection />,
      },
      {
        id: "organizations",
        label: "Organisasjoner",
        content: <OrganizationsSection />,
      },
      {
        id: "endpoints",
        label: "Endpoint-grupper",
        content: <EndpointGroupsSection />,
      },
      {
        id: "pages",
        label: "Sider",
        content: <PagesSection />,
      },
    ],
    [],
  );

  return (
    <div className={styles.page} data-testid="superadmin-page">
      <SectionHeader as="h1" size="lg" className={styles.title}>
        Superadministrasjonspanel
      </SectionHeader>
      <Tabs tabs={tabs} defaultTab="admins" data-testid="superadmin-tabs" />
    </div>
  );
};

export default SuperadminPage;
